export class Common {

  constructor() {

  }

  init_header_nav() {
    // ヘッダーメニュー　大トグルボタンの設定
    const headerWrap = document.getElementById('js-HeaderWrap');
    const headerDrawerToggle = document.getElementById('js-HeaderDrawerToggle');
    const headerNav = document.getElementById('js-HeaderNav');
    const headerNavMenu = document.getElementById('js-HeaderNavMenu');

    headerDrawerToggle.addEventListener('click', () => {
      headerDrawerToggle.classList.toggle('open');
      headerNav.classList.toggle('open');
      headerNavMenu.classList.toggle('open');

      // 閉じるときの処理
      if (headerWrap.classList.contains('open')) {
        // .4sかけてclosing > remove open
        headerWrap.classList.add('closing');

        setTimeout(function () {
          headerWrap.classList.remove('closing');
        }, 400);

        headerWrap.classList.remove('open');
      } else {
        headerWrap.classList.add('open');
        headerWrap.classList.remove('closing');
      }
    });
  }
}